export let journalGoalLabels: { [index: number]: string } = {
  1: 'Monthly',
  2: 'Annual',
  3: 'One Time',
};

export let monthlyGoalTypeId = 1;
export let annualGoalTypeId = 2;
export let oneTimeGoalTypeId = 3;
